import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import AvailabilitiesField from '../../components/AvailabilitiesField';
import AvailabilitiesSlotsField from '../../components/AvailabilitiesSlotsField';
import store from '../../redux';
import {
    AVAILABILITY_MODE_MANUAL,
    AVAILABILITY_MODE_SLOTS,
} from '../../services/availabilitySlots';

/** Class representing an availabilities form field. */
class AvailabilitiesSelectorField extends TextField {

    constructor(properties) {
        super({
            ...(AvailabilitiesSelectorField.getDefaultOptions()),
            ...properties,
            name: 'availabilities',
        });

        this.type = FormLayout.AVAILABILITIES;

        if (!this.content || typeof this.content !== 'object') {
            this.content = { ...(AvailabilitiesSelectorField.getDefaultOptions().content) };
        }
        if (!this.content.mode) {
            this.content.mode = AVAILABILITY_MODE_MANUAL;
        }
        if (!Array.isArray(this.content.phase_ids)) {
            this.content.phase_ids = [];
        }
        if (!Array.isArray(this.content.period_ids)) {
            this.content.period_ids = [];
        }
    }

    /**
     * Get this field default options
     */
    static getDefaultOptions() {
        const properties = super.getDefaultOptions();

        properties.name = 'availabilities';
        properties.required = true;
        properties.content = {
            mode: AVAILABILITY_MODE_MANUAL,
            phase_ids: [],
            period_ids: [],
        };

        return properties;
    }

    getMode() {
        return this.content?.mode === AVAILABILITY_MODE_SLOTS
            ? AVAILABILITY_MODE_SLOTS
            : AVAILABILITY_MODE_MANUAL;
    }

    /**
     * Return the list of options this field handles
     */
    getHandledOptions() {
        return [
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_LABEL,
            FormLayout.OPTION_DESCRIPTION,
            FormLayout.OPTION_REQUIRED,
            FormLayout.OPTION_AVAILABILITY_MODE,
            FormLayout.OPTION_AVAILABILITY_PHASES,
            FormLayout.OPTION_AVAILABILITY_PERIODS,
        ];
    }

    /**
     * Return this field preview as JSX string
     */
    getPreview(props) {
        return (
            <div className="field-wrapper form-group">
                { this.getPreviewLabel(props) }
                { this.getDescription(props) }
                <div className="input">{ this.getPreviewInput(props) }</div>
            </div>
        );
    }

    /**
     * Return this field preview input
     */
    getInput(props) {
        const mode = this.getMode();
        let phases = props.resources?.phases || [];
        let periods = props.resources?.periods || [];

        if (!phases?.length) {
            phases = store?.getState()?.phases?.phases || [];
        }
        if (!periods?.length) {
            periods = store?.getState()?.periods?.periods || [];
        }

        const phaseIds = this.content?.phase_ids || [];
        const periodIds = this.content?.period_ids || [];

        if (mode === AVAILABILITY_MODE_SLOTS) {
            if (phaseIds.length) {
                phases = phases.filter((phase) => phaseIds.includes(phase.id));
            }
            if (periodIds.length) {
                periods = periods.filter((period) => periodIds.includes(period.id));
            }

            return (
                <AvailabilitiesSlotsField
                    phases={phases}
                    periods={periods}
                    lang={props.lang}
                />
            );
        }

        return (
            <AvailabilitiesField
                preventSubmit
                name="availabilities"
                phases={phases}
            />
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'calendar';
    }
}

export default AvailabilitiesSelectorField;
